var map = {
	"./add-file.svg": 150,
	"./add-folder.svg": 151,
	"./css.svg": 446,
	"./file.svg": 447,
	"./folder-open.svg": 448,
	"./folder.svg": 449,
	"./html.svg": 450,
	"./javascript.svg": 451,
	"./jpg.svg": 452,
	"./json.svg": 453,
	"./negative.svg": 152,
	"./pdf.svg": 454,
	"./png.svg": 455,
	"./txt.svg": 456,
	"./xml.svg": 457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;